import { FC, ReactNode } from "react";
import Restricted from "@/consumer/restricted";
import MissingPagePermission from "@/components/general/missingPagePermission";

interface RestrictedPageProps {
  permissionRequired: string;
  children: ReactNode;
}

const RestrictedPage: FC<RestrictedPageProps> = ({
  permissionRequired,
  children,
}) => (
  <Restricted
    permissionRequired={permissionRequired}
    fallback={<MissingPagePermission permissionRequired={permissionRequired} />}
  >
    {children}
  </Restricted>
);

export default RestrictedPage;
